/*! @azure/msal-browser v3.6.0 2023-12-01 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";

export { contentError, userSwitch };
//# sourceMappingURL=NativeAuthErrorCodes.mjs.map
